// removed by extract-text-webpack-plugin
module.exports = {"pageContainer":"pageContainer__3B371","cardContainer":"cardContainer__2KRPD","subtitle":"subtitle__3yisb"};


//////////////////
// WEBPACK FOOTER
// ./routes/accountdeletion/style.css
// module id = 9ryv
// module chunks = 1